<!-- <div class="content-wrapper">
  <div class="content-body">
    <div class="row">
      <div class="col-md-6 col-lg-4" *ngFor="let item of getAllEndpoint">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title">{{ item.name }}</h4>
            <span class="badge badge-glow badge-primary">{{ item.actions.length }}</span>
          </div>
          <div class="card-body" style="max-height: 300px; overflow-y: auto;">
            <ul class="list-group">
              <li class="list-group-item d-flex justify-content-between align-items-center"
                *ngFor="let action of item.actions">
                {{ translate(item.name, action.definition) }}
                <button type="button" class="btn btn-icon btn-flat-success" rippleEffect
                  *ngIf="authService.isEndpointStatus('POST.Writing.AssingRoleEndpoint') && authService.isEndpointStatus('POST.Reading.GetRolesToEndpoint')"
                  (click)="addEvent(modalSM, item.name, action.code)">
                  <i data-feather="plus"></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->


<!-- <div class="content-wrapper">
  <div class="content-body">
    <div class="row col-12">
      <div class="col-md-4" *ngFor="let item of getAllEndpoint">
        <div class="select-container">
          <label>{{ item.name }}</label>
          <ng-select [items]="item.actions" bindLabel="translatedDefinition" bindValue="action"
            (change)="onSelectItem(modalSM, $event, item.name)">
            <ng-option *ngFor="let action of item.actions" [value]="action">
              {{ action.translatedDefinition }}
            </ng-option>
          </ng-select>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!--List hali bu-->
<div class="col-xl-3 col-md-6 col-sm-12">
  <select class="form-control" name="role" id="role" [(ngModel)]="selectedRole" (change)="onRoleChange()">
    <option value="">Role Seç</option>
    <option *ngFor="let item of data" [value]="item.name">{{item.name}}</option>
  </select>
</div>

<div class="content-wrapper">
  <div class="content-body">
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Yetki Adı</th>
            <th>Okuma</th>
            <th>Yazma</th>
            <th>Güncelleme</th>
            <th>Silme</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of getAllEndpoint">
            <td>{{ item.name }}</td>
            <td>
              <div *ngFor="let read of filterActionsByType(item.actions,'Reading')">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                    id="customCheckRead{{item.name}}_{{read.translatedDefinition}}" [(ngModel)]="read.selected" />
                  <label class="custom-control-label" for="customCheckRead{{item.name}}_{{read.translatedDefinition}}">
                    {{read.translatedDefinition}}
                  </label>
                </div>
              </div>
            </td>
            <td>
              <div *ngFor="let writing of filterActionsByType(item.actions,'Writing')">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                    id="customCheckWrite{{item.name}}_{{writing.translatedDefinition}}"
                    [(ngModel)]="writing.selected" />
                  <label class="custom-control-label"
                    for="customCheckWrite{{item.name}}_{{writing.translatedDefinition}}">
                    {{writing.translatedDefinition}}
                  </label>
                </div>
              </div>
            </td>
            <td>
              <div *ngFor="let update of filterActionsByType(item.actions,'Updateing')">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                    id="customCheckUpdate{{item.name}}_{{update.translatedDefinition}}" [(ngModel)]="update.selected" />
                  <label class="custom-control-label"
                    for="customCheckUpdate{{item.name}}_{{update.translatedDefinition}}">
                    {{update.translatedDefinition}}
                  </label>
                </div>
              </div>
            </td>
            <td>
              <div *ngFor="let delete of filterActionsByType(item.actions,'Deleteing')">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                    id="customCheckDelete{{item.name}}_{{delete.translatedDefinition}}" [(ngModel)]="delete.selected" />
                  <label class="custom-control-label"
                    for="customCheckDelete{{item.name}}_{{delete.translatedDefinition}}">
                    {{delete.translatedDefinition}}
                  </label>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-primary" (click)="saveSelections()">Kaydet</button>
    </div>
  </div>
</div>

<!-- <div class="content-wrapper">
  <div class="content-body">
  
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-md-6 col-lg-4" *ngFor="let item of getAllEndpoint">
            <div class="card mb-4">
              <div class="card-header d-flex justify-content-between align-items-center">

                <h4 class="card-title">{{item.name}}</h4>
                <div class="avatar bg-primary bg-darken-2">
                  <div class="avatar-content">{{item.actions.length}}</div>
                </div>
              </div>
              <div class="card-body">


                <ul class="list-group list-group-flush" *ngFor="let action of item.actions">
                  <p>

                    <br>
                    {{ translate(item.name,action.definition) }}

                    <button type="button" class="btn btn-icon btn-flat-success" rippleEffect
                      (click)="addEvent(modalSM,item.name,action.code)">
                      <span [data-feather]="'plus'"></span></button>
                  </p>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<ng-template #modalSM let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{menu}} <sub>{{code}}</sub></h5>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="custom-control custom-checkbox" *ngFor="let action of data">
      <input type="checkbox" class="custom-control-input" id="{{action.id}}" [checked]="action.checked"
        (change)="toggleCheckbox(action)" />
      <label class="custom-control-label" for="{{action.id}}">{{action.name}}</label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close('Success')" rippleEffect>
      Kaydet
    </button>
    <button type="button" class="btn btn-primary" (click)="modal.close('Accept click')">İptal</button>
  </div>
</ng-template>